/**
 * Một đường dẫn his-web có nằm trong gói của phòng khám không (ADR-0053).
 *
 * Cùng luật khớp với `ScreenCatalog.forPath` ở máy chủ: khớp theo ranh giới đoạn đường dẫn —
 * `/patients/42/edit` thuộc `/patients`, còn `/patients-export` thì không — và tiền tố dài nhất
 * thắng. Dữ liệu (màn hình nào sở hữu đường dẫn nào) đến từ máy chủ; ở đây chỉ có phép khớp.
 */
import type { PlanScreen } from "../api/planScreens";

export function screenForPath(screens: PlanScreen[], pathname: string): PlanScreen | undefined {
  let best: { screen: PlanScreen; length: number } | undefined;
  for (const screen of screens) {
    for (const route of screen.routes) {
      const owns = pathname === route || pathname.startsWith(route + "/");
      if (owns && (!best || route.length > best.length)) {
        best = { screen, length: route.length };
      }
    }
  }
  return best?.screen;
}

/** Đường dẫn không thuộc màn hình nào (trang cá nhân, chuyển hướng) thì luôn được phép. */
export function pathAllowed(screens: PlanScreen[], pathname: string): boolean {
  return screenForPath(screens, pathname)?.allowed ?? true;
}

/**
 * Màn hình không có đường dẫn riêng — một tab bên trong màn hình khác — được hỏi theo MÃ, vì không
 * có đường dẫn nào để hỏi. Mã lạ (máy chủ cũ hơn frontend) thì cho qua: thêm một màn hình vào danh
 * mục không được làm một tab đang dùng biến mất trong lúc deploy lệch nhau.
 */
export function screenAllowed(screens: PlanScreen[], code: string): boolean {
  return screens.find((screen) => screen.code === code)?.allowed ?? true;
}
